<template>
  <component
      :is="currentIcon.name"
      :class="currentIcon.class"
      class="loading-indicator__wrapper"
      v-bind="$attrs"
      v-if="currentIcon && slim"
  >
  </component>
</template>
<script>
import { ref, watch, computed } from 'vue';
import { constants } from '@/utils';
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      required: true,
    },
    size: {
      default: 'normal',
    },
    isFullScreen: Boolean,
    isAbsolute: Boolean,
    speed: {
      default: 'normal',
    },
    slim: Boolean,
    autoHide: Boolean
  },
  emits: ['update:modelValue'],
  components: {
  },
  setup(props, { emit }) {
    const finalIcon = ref(null);
    const currentIcon = computed(() => {
      if (props.modelValue === true || props.modelValue === 'updating') {
        return {
          name: 'LoaderIcon',
          class: `loading-indicator__icon spin is-${props.speed}`,
        };
      } else if (finalIcon.value === 'success') {
        return {
          name: 'CheckIcon',
          class: 'loading-indicator__icon-success',
        };
      } else if (finalIcon.value === 'error') {
        return {
          name: 'AlertCircleIcon',
          class: 'loading-indicator__icon-error',
        };
      }
      return null;
    });

    let clearFinalIconTimeout;
    watch(
        () => props.modelValue,
        newValue => {
          if (
              !newValue ||
              typeof newValue === 'boolean' ||
              newValue === 'updating'
          )
            return;

          finalIcon.value = newValue;

          if(props.autoHide) {
            clearTimeout(clearFinalIconTimeout);
            clearFinalIconTimeout = setTimeout(() => {
              finalIcon.value = null;
              emit('update:modelValue', null);
            }, constants.loadingAnimationDuration);
          }

        }
    );

    return {
      currentIcon,
      finalIcon,
    };
  },
};
</script>
<style lang="scss">
.loading-indicator {
  &__wrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &.is-full-screen {
      position: fixed;
      z-index: 1000;
      width: 100%;
      height: 100%;
      flex-direction: column;
      background-color: rgba(white, 0.6);
      backdrop-filter: blur(5px);
      svg {
        width: 30px;
        height: 30px;
        animation-duration: 0.5s;
      }
    }
    &.is-absolute {
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }
  &__icon {
    stroke: var(--platinum);
    width: 14px;
    height: 14px;
    &.size-s {
      width: 10px;
      height: 10px;
    }
    &.size-l {
      width: 18px;
      height: 18px;
    }
    &-success,
    &-error {
      width: 14px;
      height: 14px;
    }
    &-success {
      stroke: white;
      background-color: var(--amazonite);
      border-radius: 28px;
      padding: 1px;
    }
    &-error {
      stroke: var(--orange-pantone);
    }
  }
  &__wrapper svg {
    &.is-normal {
      animation-duration: 0.5s;
    }
  }
}
</style>
